import { render, staticRenderFns } from "./WyfStats.vue?vue&type=template&id=e61ead06"
import script from "./WyfStats.vue?vue&type=script&lang=ts"
export * from "./WyfStats.vue?vue&type=script&lang=ts"
import style0 from "./WyfStats.vue?vue&type=style&index=0&id=e61ead06&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports